class ProductCarousel extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.product-carousel__track');
    this.prevBtn = this.querySelector('.product-carousel__arrow--prev');
    this.nextBtn = this.querySelector('.product-carousel__arrow--next');
    this.dotsWrap = this.querySelector('.product-carousel__dots');
    this.slides = Array.from(this.querySelectorAll('.product-carousel__slide'));
  }

  connectedCallback() {
    if (!this.track) return;

    this.prevBtn?.addEventListener('click', () => this.scrollByAmount(-1));
    this.nextBtn?.addEventListener('click', () => this.scrollByAmount(1));
    this.track.addEventListener('scroll', () => this.updateArrowState(), { passive: true });
    window.addEventListener('resize', () => this.updateArrowState());

    if (this.dotsWrap) this.buildDots();
    this.updateArrowState();
    this.bindWishlistButtons();
    this.bindQuickAddForms();
  }

  getSlideStep() {
    const slide = this.slides[0];
    if (!slide) return this.track.clientWidth;
    const style = getComputedStyle(this.track);
    const gap = parseFloat(style.columnGap || style.gap || '0');
    return slide.getBoundingClientRect().width + gap;
  }

  scrollByAmount(direction) {
    const step = this.getSlideStep();
    this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
  }

  updateArrowState() {
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const maxScroll = scrollWidth - clientWidth - 1;

    if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 0;
    if (this.nextBtn) this.nextBtn.disabled = scrollLeft >= maxScroll;

    if (this.dotsWrap) this.updateActiveDot();
  }

  buildDots() {
    this.dotsWrap.innerHTML = '';
    const visible = Math.max(1, Math.round(this.track.clientWidth / this.getSlideStep()));
    const positions = this.slides.length - visible + 1;
    if (positions < 2) return;
    this.slides.slice(0, positions).forEach((slide, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', `Ir al producto ${index + 1}`);
      dot.addEventListener('click', () => {
        this.track.scrollTo({ left: slide.offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' });
      });
      this.dotsWrap.appendChild(dot);
    });
  }

  updateActiveDot() {
    const dots = Array.from(this.dotsWrap.children);
    if (!dots.length) return;
    const { scrollLeft } = this.track;
    let closestIndex = 0;
    let closestDistance = Infinity;

    this.slides.forEach((slide, index) => {
      const distance = Math.abs(slide.offsetLeft - this.track.offsetLeft - scrollLeft);
      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    dots.forEach((dot, index) => {
      dot.setAttribute('aria-current', index === closestIndex ? 'true' : 'false');
    });
  }

  bindWishlistButtons() {
    this.querySelectorAll('.product-card__wishlist').forEach((button) => {
      button.addEventListener('click', () => {
        const pressed = button.getAttribute('aria-pressed') === 'true';
        button.setAttribute('aria-pressed', String(!pressed));
      });
    });
  }

  bindQuickAddForms() {
    this.querySelectorAll('.product-card__quick-add-form').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const button = form.querySelector('.product-card__quick-add');
        const formData = new FormData(form);

        if (button) button.disabled = true;

        fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status) {
              console.warn('No se pudo añadir el producto al carrito:', data.description || data.message);
              return;
            }
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
          })
          .catch((error) => console.error('Error al añadir al carrito:', error))
          .finally(() => {
            if (button) button.disabled = false;
          });
      });
    });
  }
}

customElements.define('product-carousel', ProductCarousel);